// validation.js
export const validateUserForm = (formData) => {
  let errors = {};

  // Name validation
  if (!formData.name || !formData.name.trim()) {
    errors.name = "Name is required";
  }

  // ID validation
  if (!formData.id) {
    errors.id = "ID is required";
  } else if (isNaN(formData.id)) {
    errors.id = "ID must be a number";
  }

  // Email validation
  if (!formData.email) {
    errors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = "Email address is invalid";
  }

  // Password validation
  if (!formData.password) {
    errors.password = "Password is required";
  } else if (formData.password.length < 6) {
    errors.password = "Password must be at least 6 characters";
  }

  return errors;
};

export const validatePaymentForm = (data) => {
  let errors = {};

  if (!data.paymentMethod) {
    errors.paymentMethod = "Payment Method is required";
  }

  if (!data.balance) {
    errors.balance = "Balance is required";
  } else if (isNaN(data.balance)) {
    errors.balance = "Balance must be a number";
  }

  if (!data.Maximum || isNaN(data.Maximum) || data.Maximum <= 0) {
    errors.Maximum = "Maximum Amount must be a positive number";
  }

  if (!data.type) {
    errors.type = "Payment Type is required";
  }

  return errors;
};

export const validateselectedIdForm = (data) => {
  let errors;

  if (data.length === 0) {
    errors = "At least one store must be selected";
  }

  return errors;
};
